import type { TFunction } from 'next-i18next';
import type { SquareFootage } from 'domain/listing/value-objects';
import { LOCALE_COMMON_PATHS, LOCALE_SEARCH_PATHS } from 'types/locales';

const PLACEHOLDER = '--';

export function formatSquareFootage(sqft: SquareFootage, t: TFunction): string {
  if (!sqft.hasValue) {
    return PLACEHOLDER;
  }

  if (sqft.isRange) {
    return t(LOCALE_SEARCH_PATHS.FILTER_CHIP_SQFT_RANGE_FORMAT, {
      min: sqft.min!.toLocaleString(),
      max: sqft.max!.toLocaleString(),
      defaultValue: `${sqft.min!.toLocaleString()}-${sqft.max!.toLocaleString()} sqft`,
    });
  }

  return t(LOCALE_COMMON_PATHS.LISTING_CARD_NUMBER_OF_SQFT, {
    count: sqft.value,
    defaultValue: `${sqft.value!.toLocaleString()} sqft`,
  });
}
